import axios from 'axios'
import store from './vuex/store'
import {getServerApi} from './config/deployment'
import { getCurrentUserToken, getAnyFirebaseToken } from './platform/auth/services/authService.js'

let envUri = getServerApi()
let maaklerListingsUri = envUri+'/api/listings/maakler'
let internalListingUri = envUri+'/api/listings/internal'

// Any listing id will do here (object or maaklerID)
export const getInternalListingPublic = (listingId) => {
  return getCurrentUserToken()
    .then(token => {
      return axios.get(internalListingUri, {
        params: {
          token: token,
          listingId: listingId
        }
      })
    })
    .then(resp => {
      if(resp.data.code ==200) return resp.data.body
      else return "error"
    })
    .catch(err => {
      console.log("getInternalListingPublic | err: ", err)
      return "error"
    })
}

export const saveListingEdit = (data, id, accountId) => {
  return getCurrentUserToken()
    .then(res => {
      let accountId = store.getters.selectedAccount
      if(!accountId) throw "missing selectedAccount id"
      return axios.put(maaklerListingsUri+'/save', data, {
        params: {
          token: res,
          id: id,
          accountId: accountId
        }
      })
    })
    .then(resp => {
      return resp.data
    })
    .catch(err => {
      console.log("saveListingEdit | err: ", err)
    })
}

export const getFilteredMaaklerListingsLite = (filter) => {
  try{
    getAnyFirebaseToken()
      .then(token => {
        //return dummyResponse
        return axios.get(maaklerListingsUri+'/filtered', {
          params: {
            token: token,
            municipality: filter.municipality,
            priceDailyFrom: filter.priceDailyFromInc,
            priceDailyTo: filter.priceDailyToInc,
            priceMonthlyFrom: filter.priceMonthlyFromInc,
            priceMonthlyTo: filter.priceMonthlyToInc,
            bedroomsMin: filter.bedroomsMinInc,
            bedroomsMax: filter.bedroomsMaxInc
          }
        })
        .then(resp => {
          if(resp.data.code == 200) {
            return resp.data.body
          }
          throw Error(resp.data.message)
        })
        .catch(err =>{
          return []
        })
      })
  }catch(err){
    return []
  }
}

export const getMaaklerListingsLiteOlderThen = (olderThanUnix, howmany, filter) => {
  return new Promise((resolve, reject) => {
    getAnyFirebaseToken()
      .then(token => {
        var config= {
          params:{
            token: token,
            olderthan: olderThanUnix,
            howmany: howmany,
            municipality: filter.municipality,
            priceDailyFrom: filter.priceDailyFromInc,
            priceDailyTo: filter.priceDailyToInc,
            priceMonthlyFrom: filter.priceMonthlyFromInc,
            priceMonthlyTo: filter.priceMonthlyToInc,
            bedroomsMin: filter.bedroomsMinInc,
            bedroomsMax: filter.bedroomsMaxInc
          }
        }
        if(filter.termType)config.params.termType=filter.termType

        return axios.get(maaklerListingsUri+'/filtered', config)
          
      }) 
      .then(resp => {
        if(resp.data.code == 200) resolve(resp.data.body)
        else resolve([])
      })
      .catch(err =>{
        console.log("getMaaklerListingsLiteOlderThen | err", err)
        resolve([])
      })
  })
}

export let getListingCoverThumbnail=function(listing){
  for (var i = 0, len = listing.marketingDet.images.length; i < len; i++) {
    var image = listing.marketingDet.images[i]
    // return thumbnail url not the full img url
    if(image.cover == true) return image.thumb
  }
  return require('./assets/placeholder.png')
}

export let getListingCoverImage=function(listing){
  for (var i = 0, len = listing.marketingDet.images.length; i < len; i++) {
    var image = listing.marketingDet.images[i]
    // return thumbnail url not the full img url
    if(image.cover == true) return image.url
  }
  return require('./assets/placeholder.png')
}



// WEBPACK FOOTER //
// ./src/listingsRepository.js